import React from "react";
import "../HomeFinancialCrime.css";
import { Link } from "react-router-dom";

import {
  FiArrowRight,
  FiShield,
  FiAlertTriangle,
  FiUserCheck,
  FiGlobe,
  FiActivity,
  FiFileText,
  FiCheckCircle,
} from "react-icons/fi";

const features = [
  {
    icon: <FiAlertTriangle />,
    title: "AML Monitoring",
    desc: "Detect suspicious activities and monitor financial transactions in real time.",
  },
  {
    icon: <FiUserCheck />,
    title: "KYC Verification",
    desc: "Verify customer identities through secure digital onboarding processes.",
  },
  {
    icon: <FiGlobe />,
    title: "Sanctions Screening",
    desc: "Screen customers against global sanctions and regulatory watchlists.",
  },
  {
    icon: <FiShield />,
    title: "Fraud Prevention",
    desc: "Reduce financial fraud with intelligent monitoring and risk controls.",
  },
  {
    icon: <FiActivity />,
    title: "Risk Assessment",
    desc: "Identify high-risk customers and transactions with automated scoring.",
  },
  {
    icon: <FiFileText />,
    title: "Regulatory Reporting",
    desc: "Generate compliance-ready reports that support regulatory obligations.",
  },
];

const HomeFinancialCrime = () => {
  return (
    <section className="financial-crime">

      <div className="container">

        {/*==============================
              LEFT DASHBOARD
        ==============================*/}

        <div className="crime-dashboard">

          <div className="dashboard-top">

            <div className="dashboard-dots">
              <span className="red"></span>
              <span className="yellow"></span>
              <span className="green"></span>
            </div>

            <h4>Financial Crime Dashboard</h4>

          </div>

          {/* KPI */}

          <div className="dashboard-kpis">

            <div className="dashboard-kpi">
              <h3>98%</h3>
              <span>Compliance Score</span>
            </div>

            <div className="dashboard-kpi">
              <h3>08</h3>
              <span>AML Alerts</span>
            </div>

            <div className="dashboard-kpi">
              <h3>256</h3>
              <span>Cases Closed</span>
            </div>

            <div className="dashboard-kpi">
              <h3>24×7</h3>
              <span>Monitoring</span>
            </div>

          </div>

          {/* Analytics */}

          <div className="analytics-chart">

            <div className="chart-bar b1"></div>
            <div className="chart-bar b2"></div>
            <div className="chart-bar b3"></div>
            <div className="chart-bar b4"></div>
            <div className="chart-bar b5"></div>
            <div className="chart-bar b6"></div>

          </div>

          {/* Floating Cards */}

          <div className="floating-card card-one">
            🚨 Suspicious Activity
          </div>

          <div className="floating-card card-two">
            🛡 Secure Monitoring
          </div>

          <div className="floating-card card-three">
            📊 Risk Analytics
          </div>

        </div>

        {/*==============================
                RIGHT CONTENT
        ==============================*/}

        <div className="crime-content">

          <span className="crime-tag">
            FINANCIAL CRIME COMPLIANCE
          </span>

          <h2>
            Protecting Financial Institutions Against
            <span> Financial Crime & Regulatory Risks</span>
          </h2>

          <p>
            Saivari Fintech Private Limited delivers intelligent
            Financial Crime Compliance solutions that help banks,
            NBFCs, payment providers, and fintech organizations
            detect suspicious activities, strengthen compliance,
            reduce operational risks, and meet evolving regulatory
            requirements with confidence.
          </p>

          {/* FEATURES */}

          <div className="crime-features">

            {features.map((item, index) => (

              <div
                className="crime-feature"
                key={index}
              >

                <div className="crime-icon">
                  {item.icon}
                </div>

                <div>

                  <h4>{item.title}</h4>

                  <p>{item.desc}</p>

                </div>

              </div>

            ))}

          </div>

          {/* Bottom Stats */}

          {/* <div className="crime-stats">

            <div>
              <FiCheckCircle />
              <span>Enterprise Security</span>
            </div>

            <div>
              <FiCheckCircle />
              <span>Global Compliance</span>
            </div>

            <div>
              <FiCheckCircle />
              <span>Risk Intelligence</span>
            </div>

            <div>
              <FiCheckCircle />
              <span>Real-Time Monitoring</span>
            </div>

          </div> */}

          {/* <a
            href="/about"
            className="crime-btn"
          >
            Explore More
            <FiArrowRight />
          </a> */}

        </div>

      </div>

    </section>
  );
};

export default HomeFinancialCrime;